// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-tab[data-v-1d9a9783]{height:calc(100vh - 160px)!important}", ""]);
// Exports
module.exports = exports;
